import CapLanguageProviderReducer from '@capillarytech/cap-ui-library/CapLanguageProvider/reducer';
import capReducer from './components/pages/Cap/reducer';

export const initialReducer = {
  language: CapLanguageProviderReducer,
  badgesCap: capReducer,
}
